const colorBackground = '#fcfaf2';
const colorBorder = '1px solid #ded47b';
const errorBackground = '#fff';
const errorBorderColor = '2px solid #ff9662';

// змінює стилі інпутів в залежності від валідності введених даних
// el - DOM елемент інпуту
// isValid - булеве значення валідності введених даних
export function changeInputsStyled(el, isValid) {
  if (isValid) {
    changeBgColor(el, colorBackground);
    changeBorderColor(el, colorBorder);
  } else {
    changeBgColor(el, errorBackground);
    changeBorderColor(el, errorBorderColor);
  }
}

export function changeBgColor(el, currentColor = colorBackground) {
  el.style.background = currentColor;
}

export function changeBorderColor(el, currentColor = colorBorder) {
  el.style.border = currentColor;
}
